module.exports = __webpack_public_path__ + "static/media/unaro-yellow-background.c2899865.svg";